module.exports = __webpack_public_path__ + "images/5bda3c1e4debb2e1900bb03980684dc4.jpg";